import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Box, Button, Grid, makeStyles, Tooltip, IconButton, Fab, TextField } from "@material-ui/core/";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import DnerhsApi, { CancelToken } from  "../../api/DnerhsApi";
import { Link, useParams, useLocation } from "react-router-dom";
import DeleteDialog from "../../dialogs/DeleteDialog";
import history from "../../utils/History";
import Alert from "../../components/Alert";
import ResponseUtils from "../../utils/ResponseUtils";
import useAuth from "../../hooks/Auth";
import Roles from "../../constants/Roles";
import * as XLSX from 'xlsx'; // Importa la librería xlsx
import ExcelIcon from '@material-ui/icons/Assessment'; // Puedes usar otro icono de Excel
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
  exportButton: { // Estilo para el botón de exportación
    margin: theme.spacing(1),
  },
}));

const List = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(3);
  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]); // Estado para almacenar todos los datos
  const [openDialog, setOpenDialog] = useState(false);
  const [toDelete, setToDelete] = useState();
  const { hasRole, hasAnyRole } = useAuth();
  const params = useParams();
  const { userData } = useAuth();
  const isAdmin = userData && userData.role.descripcion === "ROLE_ADMIN";
  const [profesion, setProfesion] = useState();
  const [loadingFullData, setLoadingFullData] = useState(false);

  let location = useLocation();

  useEffect(() => {
    const load = () => {
      try {
        loadData({ page, rowsPerPage });
        setProfesion(location?.state?.profesion);
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, [page, rowsPerPage, params.establecimientoProfesionId, location?.state?.profesion]); // Dependencias actualizadas

  const loadData = async ({ page = 0, rowsPerPage = 10 }) => {
    let source = CancelToken.source();
    try {
      let url = `/establecimientos-profesiones-profesionales/${params.establecimientoProfesionId}/profesionales/page?page=${page}&pageSize=${rowsPerPage}`;
      const response = await DnerhsApi(url, {
        cancelToken: source.token,
      });
      const { data: rows, totalElements } = response;
      setRows(rows.content);
      setTotalElements(rows.totalElements);
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    }
  };

  const loadAllData = async () => {
    setLoadingFullData(true);
    let source = CancelToken.source();
    try {
      let url = `/establecimientos-profesiones-profesionales/${params.establecimientoProfesionId}/profesionales`; // Endpoint sin paginación
      const response = await DnerhsApi(url, {
        cancelToken: source.token,
      });
      setAllRows(response.data);
      downloadExcel(response.data);
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    } finally {
      setLoadingFullData(false);
    }
  };

  const downloadExcel = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data.map(row => ({
      'Establecimiento': row.establecimientoProfesion?.nombreServicio?.nombre || '',
      'Cédula Identidad': row.profesional?.cedulaIdentidad || '',
      'Nombres': row.profesional?.nombres || '',
      'Apellidos': row.profesional?.apellidos || '',
      'Profesión': row.establecimientoProfesion?.profesion?.descripcion || '',
      'Registro': row.profesional?.numeroRegistroProfesionalVigente || '',
      // Agrega aquí más columnas según tus necesidades
    })));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Profesionales');
    XLSX.writeFile(workbook, 'profesionales.xlsx');
  };

  const handleChangePage = async (event, newPage) => {
    setRows([]);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    setRows([]);
  };

  const deleteOne = async () => {
    let source = CancelToken.source();
    try {
      let url = `/establecimientos-profesiones-profesionales/${toDelete}`;
      await DnerhsApi.delete(url, {
        cancelToken: source.token,
      });
      Alert.show({ message: "Eliminado exitosamente.", type: "success" });
      loadData({ page, rowsPerPage });
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    }
    setOpenDialog(false);
    setToDelete();
  };

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }
    Alert.show({ message, type: "error" });
  };

  const handleOpenDialog = (id) => {
    setOpenDialog(true);
    setToDelete(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const fetchAllData = async () => {
    setLoadingFullData(true);
    let source = CancelToken.source();
    try {
      let url = `/establecimientos-profesiones-profesionales/${params.establecimientoProfesionId}/profesionales`; // Sin paginación
      const response = await DnerhsApi(url, {
        cancelToken: source.token,
      });
      setAllRows(response.data);
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    } finally {
      setLoadingFullData(false);
    }
  };
  useEffect(() => {
    if (searchTerm !== "") {
      fetchAllData();
    }
  }, [searchTerm]);
  const filteredRows = (searchTerm ? allRows : rows).filter((row) => {
    const values = [
      row.establecimientoProfesion?.nombreServicio?.nombre,
      row.profesional?.cedulaIdentidad,
      row.profesional?.nombres,
      row.profesional?.apellidos,
      row.establecimientoProfesion?.profesion?.descripcion,
      row.profesional?.numeroRegistroProfesionalVigente,
    ];
    return values.some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper>
          <Box p={1}>
            <Typography
              variant="h5"
              color="primary"
              align="center"
              className={classes.title}
            >
              Profesional - {profesion}
            </Typography>
            
           
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Box mb={2} display="flex" justifyContent="flex-end">
                <TextField
                  label="Buscar en tabla"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className={classes.searchInput}
                  size="small"
                />
                <SearchIcon />
            </Box>
              <Button
                variant="contained"
                color="secondary"
                className={classes.exportButton}
                startIcon={<ExcelIcon />}
                onClick={loadAllData}
                disabled={loadingFullData}
              >
                Exportar a Excel
              </Button>
            </Box>


            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Establecimiento</TableCell>
                  <TableCell align="left">Cédula Identidad</TableCell>
                  <TableCell align="left">Nombres</TableCell>
                  <TableCell align="left">Apellidos</TableCell>
                  <TableCell align="left">Profesion</TableCell>
                  <TableCell align="left">Registro</TableCell>
                  <TableCell align="center">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {filteredRows.map((row, index) => (
                
                  <TableRow key={index}>
                    <TableCell align="left">
                      {row.establecimientoProfesion?.nombreServicio?.nombre}
                    </TableCell>
                    <TableCell align="left">
                      {row.profesional?.cedulaIdentidad}
                    </TableCell>
                    <TableCell align="left">
                      {row.profesional?.nombres}
                    </TableCell>
                    <TableCell align="left">
                      {row.profesional?.apellidos}
                    </TableCell>
                    <TableCell align="left">
                      {row.establecimientoProfesion?.profesion?.descripcion}
                    </TableCell>
                    <TableCell align="left">
                      {row.profesional?.numeroRegistroProfesionalVigente}
                    </TableCell>
                    <TableCell align="center">
                      {!isAdmin && (
                        <>
                          <Tooltip title="Editar" aria-label="editar">
                            <IconButton
                              size="small"
                              aria-label="editar"
                              color="primary"
                              onClick={() => history.push({
                                pathname: `/profesionales/editar/${profesion}/${row.id}`,
                                state: { edit: true }
                              })}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Eliminar" aria-label="eliminar">
                            <IconButton
                              size="small"
                              aria-label="eliminar"
                              color="secondary"
                              onClick={() => handleOpenDialog(row.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}

                      {hasAnyRole([Roles.ROLE_ADMIN, Roles.ROLE_DNERHS, Roles.ROLE_RESPONSABLE_ESTABLECIMIENTO]) &&
                        <>
                          <Tooltip title="Ver" aria-label="Ver">
                            <IconButton
                              size="small"
                              aria-label="ver"
                              color="primary"
                              onClick={() => history.push({
                                pathname: `/profesionales/ver/${profesion}/${row.id}`,
                                state: { readOnly: true, profesional: `${row.profesional?.id}` }
                              })}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination



 
                    rowsPerPageOptions={[10, 15, 20]}
                    colSpan={7} // Actualiza el colSpan para incluir el nuevo botón
                    count={searchTerm ? filteredRows.length : totalElements}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "Registros por página" },
                      native: false,
                    }}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} de ${count}`
                    }
                    labelRowsPerPage="Registros por página"
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    hidden={searchTerm !== ""}
                  />
                </TableRow>
              </TableFooter>
            </Table>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  onClick={() => history.goBack()}
                >
                  Atrás
                </Button>
              </Grid>
              {!isAdmin && (
                <Grid item className={classes.button}>
                  <Link to={`/profesionales/crear/${profesion}/${params.establecimientoId}/${params.establecimientoProfesionId}`}>
                    <Fab color="primary" aria-label="nuevo">
                      <Tooltip title="Nuevo profesional" aria-label="nuevo">
                        <AddIcon />
                      </Tooltip>
                    </Fab>
                  </Link>
                </Grid>
              )}
            </Grid>

          </Box>
          <DeleteDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onAccept={deleteOne}
            aria-labelledby="form-dialog-title"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default List;